import { en } from './en'
import { fr } from './fr'

export const companyActivityCard = {
  en,
  fr
}